import CityPageTemplate from "../city-template/CityPageTemplate";
import { ketchikanConfig } from "./data";

export default function KetchikanPage() {
  return <CityPageTemplate config={ketchikanConfig} />;
}